module.exports = __webpack_public_path__ + "ov_12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/contact/ov/ov_12.png
// module id = 872
// module chunks = 0